import type { HITLConfig } from '../../tool-config-types';

/**
 * HITL config for signal actions
 * Handles signals arrays or single signal objects
 */
export const signalHitlConfig: HITLConfig = {
  extractData: (args: Record<string, unknown>): unknown[] => {
    if (Array.isArray(args.signals)) {
      return args.signals;
    }
    if (args.signal && typeof args.signal === 'object') {
      return [args.signal];
    }
    if (
      args.title ||
      args.description ||
      args.category ||
      args.hypothesis ||
      args.reason
    ) {
      return [args];
    }
    return [];
  },
  wrapEditedData: (data: unknown[]): Record<string, unknown> => {
    // signal-tool expects direct fields, not wrapped in array
    if (data.length === 1) {
      return data[0] as Record<string, unknown>;
    }
    return { signals: data };
  },
};
